import React from 'react';
import styled from 'styled-components';
import { MobileWidth, pmBlack, pmWhite } from '../sharedData/Constants';
import GeneralContext from '../contexts/GeneralContext';

const FormText = () => {
    return(
        <GeneralContext.Consumer>
        {data => (
            <StyledTextContainer theme={data.theme}>
                <StyledModalFormTitle theme={data.theme}>
                    ESTUDO 2024 BLACK FRIDAY: 
                </StyledModalFormTitle>
                <StyledModalFormSubTitle theme={data.theme}>
                    o que esperar e como se preparar?
                </StyledModalFormSubTitle>
                <StyledBodyText theme={data.theme}>
                    O estudo mais aguardado do ano já está disponível e, desta vez, você pode acessá-lo em um novo formato, conferindo as principais tendências e insights trazidos pela Pmweb. 
                    <br></br>
                    <br></br>

                    Além disso, você pode baixar o estudo completo no formato que você já conhece.

                </StyledBodyText>
            </StyledTextContainer>
        )}
      </GeneralContext.Consumer>
    );
};

const StyledTextContainer = styled.div`
    width:  ${props => props.theme === 'dark' ? '582px' : '366px'};
    text-align: left;
    padding-top: 35px;
    margin-right: 90px;
    @media screen and (max-width: ${MobileWidth}) {
        width: 100%;
        max-width: 446px;
        height: fit-content;
        padding: 0 0 20px;
        margin-right: 0;
    }
`;

const StyledBodyText = styled.div`
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    margin-top: 19px;
    color: rgba(255, 255, 255, 1);
    width: 500px;
    @media screen and (max-width: ${MobileWidth}) {
        font-size: 16px;
        width: 100%;
    }
`;

const StyledModalFormTitle = styled.div`
    color: ${pmWhite};
    font-size:  ${props => props.theme === 'dark' ? '32px' : '30px'};
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    @media screen and (max-width: ${MobileWidth}){
        font-size: 30px;
    }
`;
const StyledModalFormSubTitle = styled.div`
    color: ${props => props.theme === 'dark'? pmWhite: pmBlack};
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export default FormText;